// extracted by mini-css-extract-plugin
module.exports = {"container":"_-_-pharmacy-src-navigation-header-headerBanner__container--3XV3u","children":"_-_-pharmacy-src-navigation-header-headerBanner__children--khuom"};